import React from 'react';
import './NavigationArrow.css';

import icoLeft from '../../../../../../assets/img/arrow-left.png';
import icoRight from '../../../../../../assets/img/arrow-right.png';

function NavigationArrow({ type, onNav, enabled }) {
  const arrowSymbol = type < 0 ? icoLeft : icoRight;
  let arrowClass = `arrow ${type < 0 ? 'left' : 'right'}`;
  if (!enabled) {
    // todo - may set some disabled button state
    arrowClass = `${arrowClass} disabled`;
  }
  return (
    <button
      className={arrowClass}
      onClick={() => {
        onNav(type);
        window.scrollTo(0, 0);
      }}
    >
      <img src={arrowSymbol} alt="Posun dne" />
    </button>
  );
}

export default NavigationArrow;



// WEBPACK FOOTER //
// ./src/components/App/Program/Head/Navigation/NavigationArrow/NavigationArrow.js